import { render, staticRenderFns } from "./CriminalStepThree.vue?vue&type=template&id=1b3b45dd"
import script from "./CriminalStepThree.vue?vue&type=script&lang=js"
export * from "./CriminalStepThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports